import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { TmdxAvatar } from '@ds';
import { ActionMenu, MenuItemType } from '@ui';

export type UserMenuProps = {
  onOpen: () => void;
  getUserMenu: (action: (type: 'link' | 'action', to: string) => void) => MenuItemType[];
  userName?: string;
  photoPath?: string;
};

export const UserMenu = ({ onOpen, getUserMenu, userName, photoPath }: UserMenuProps) => {
  const navigate = useNavigate();

  const onMenuItemClick = useCallback(
    async (type: string, to: string) => {
      if (type === 'link') {
        navigate(to);

        return;
      }

      if (type === 'action' && to === 'sign-out') {
        onOpen();
      }
    },
    [onOpen, navigate],
  );

  const userMenu = useMemo(() => getUserMenu(onMenuItemClick), [getUserMenu, onMenuItemClick]);

  return (
    <ActionMenu
      items={userMenu}
      MenuTrigger={
        <div className="cursor-pointer">
          <TmdxAvatar size="xl" radius="xl" name={userName} src={photoPath} />
        </div>
      }
      label="User Menu"
      placement="right"
    />
  );
};
